module.exports = __webpack_public_path__ + "media/images/sp/stores/shibuya/shibuya_sns_06-b6eef650ae750fa7c67c26bba382317c.jpg";